{
    "Administrator": "Amministratore:",
    "AdministratorRole": "Ruolo di amministratore:",
    "AdministratorLanguage_ServiceNotification": "Notifica di servizio:",
    "AdministratorLanguage_ConcurrentSignins": "Sono consentite insegne contemporanee:",
    "NAME": "AdministratorLanguage"
}